import React from "react";
import Svg, { QUESTION } from "../../Svg";

function Aide({ toggle }) {
    function handleClick(e) {
        e.preventDefault();
        toggle();
    }
    return (
        <button
            className="btn btn-info  my-1 mx-1"
            title="Comment utiliser ce générateur ?"
            onClick={handleClick}
        >
            <Svg src={QUESTION} />
        </button>
    );
}

export default Aide;
